import { ReplyWithAttachmentSuggestion, ReplyWithEndpointType } from 'owa-mail-store';
import MRUAttachment from '../store/schema/MRUAttachment';
import { trace } from 'owa-trace';

export default function convertMRUAttachmentToReplyWithAttachmentSuggestion(
    mruAttachment: MRUAttachment,
    traceId: string
): ReplyWithAttachmentSuggestion {
    try {
        // Classic attachments have LastShared property while cloudy attachments do not.
        // For more robustness, also confirm that there is no "WebUrl" property if the attachment is classic.
        const isClassic: boolean =
            !!mruAttachment.Source.LastShared && !mruAttachment.Source.WebUrl;

        const author: string = mruAttachment.Source.Author
            ? mruAttachment.Source.Author.DisplayName
            : '';

        return {
            Author: author,
            CreatedBy: author,
            DateAccessed:
                mruAttachment.Source.LastAccessDateTime ||
                mruAttachment.Source.UserRelationship?.LastAccessDateTime,
            DateCreated: null,
            DateModified: mruAttachment.Source.LastModifiedDateTime,
            Endpoint: isClassic
                ? ReplyWithEndpointType.MRUClassic
                : mruAttachment.SubstrateSearchExtendedProperties?.RelevanceRelationship ===
                  'Implicit'
                ? ReplyWithEndpointType.MRUContextual
                : ReplyWithEndpointType.MRUCloudy,
            FileExtension: mruAttachment.Source.FileExtension,
            FileName: mruAttachment.Source.FileName,
            FileSize: mruAttachment.Source.FileSize,
            FileSourceType: mruAttachment.ContentSource || mruAttachment.Provenance, // provenance is deprecated, see VSO 40637
            Id: isClassic ? mruAttachment.Source.LastShared.AttachmentId : mruAttachment.Id,
            ModifiedBy: getLastModifiedBy(mruAttachment),
            ReferenceId: mruAttachment.ReferenceId,
            SourceTitle:
                mruAttachment.Source.SiteTitle || mruAttachment.Source.LastShared.SharingSubject,
            Text: mruAttachment.Source.Title,
            Title: mruAttachment.Source.Title,
            Url: mruAttachment.Source.Url,
            TraceId: traceId,
        };
    } catch (e) {
        trace.info(
            `[convertMRUAttachmentToReplyWithAttachmentSuggestion] Error accessing MRUAttachment properties: ${e.message}`
        );
        return null;
    }
}

function getLastModifiedBy(mruAttachment: MRUAttachment): string {
    // Classic attachment uses LastShared property
    // Cloudy attachment uses LastModifiedBy property
    return mruAttachment.Source.LastModifiedBy
        ? mruAttachment.Source.LastModifiedBy.DisplayName
        : mruAttachment.Source.LastShared.SharedBy.DisplayName;
}
